import { render, staticRenderFns } from "./ServiceJobList.vue?vue&type=template&id=0becdcf7&"
import script from "./ServiceJobList.vue?vue&type=script&lang=js&"
export * from "./ServiceJobList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports